import React, { useEffect, useState, useContext } from 'react';
import { StoreContext, ServerContext } from '../../App';
import Preloader from '../../pages/Preloader/Preloader';

interface AppInitializerProps {
    children: React.ReactNode;
}

/**
 * Компонент для инициализации приложения при загрузке.
 * Восстанавливает пользователя из localStorage.
 */
const AppInitializer: React.FC<AppInitializerProps> = ({ children }) => {
    const store = useContext(StoreContext);
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        const initializeApp = () => {
            //  восстановление из localStorage
            const token = store.getToken();
            if (token) {
                const savedUser = store.loadUserFromStorage();
                if (savedUser) {
                    store.setUser(savedUser);
                }
            }
            setIsInitialized(true);
        };

        initializeApp();
    }, [store]);

    if (!isInitialized) {
        return <Preloader />;
    }

    return <>{children}</>;
};

export default AppInitializer;

